require('angular')
require('../cache/cache-module')
require('../../../core/translation/translation-module')
AccountService = require('./account-service')

modules = [
  'gnp-translation'
  'gnp-cache'
]

angular.module 'gnp-account', modules
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .factory 'AccountService', AccountService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/account/account-module.coffee